import { News } from '@/model';
import {
  GetNewsCalendarNewsByIdResponse,
  GetNewsCalendarNewsItemResponse,
  GetNewsCalendarNewsResponse,
  PostNewsCalendarNewsResponse,
  PutNewsCalendarNewsResponse,
} from '@/services/response/news';

export class NewsConverter {
  static toDomainFromGetItemResponse(response: GetNewsCalendarNewsItemResponse): News {
    return {
      uuid: response.uuid,
      business_unit_uuid: response.business_unit_uuid,
      updated_at: response.updated_at,
      image_url: response.image_url,
      created_at: response.created_at,
      title: response.title,
      published_at: response.published_at,
      status: response.status,
      publish_at: response.publish_at,
      content: '',
      source_url: '',
      deleted_at: '',
      attempt_count: response.attempt_count,
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
    };
  }

  static toDomainFromPaginatedResponse(response: GetNewsCalendarNewsResponse): News[] {
    return response.data.map(NewsConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromPostResponse(response: PostNewsCalendarNewsResponse): News {
    return {
      uuid: response.uuid,
      status: response.status,
      title: response.title,
      content: response.content,
      source_url: response.source_url,
      image_url: response.image_url,
      created_at: response.created_at,
      publish_at: response.publish_at,
      updated_at: response.updated_at,
      business_unit_uuid: '',
      published_at: '',
      deleted_at: '',
    };
  }

  static toDomainFromPutResponse(response: PutNewsCalendarNewsResponse): News {
    return {
      uuid: response.uuid,
      status: response.status,
      title: response.title,
      content: response.content,
      source_url: response.source_url,
      image_url: response.image_url,
      created_at: response.created_at,
      publish_at: response.publish_at,
      updated_at: response.updated_at,
      business_unit_uuid: '',
      published_at: '',
      deleted_at: '',
    };
  }

  static toDomainFromByIdResponse(response: GetNewsCalendarNewsByIdResponse): News {
    return {
      uuid: response.uuid,
      status: response.status,
      title: response.title,
      content: response.content,
      source_url: response.source_url,
      attempt_count: response.attempt_count,
      image_url: response.image_url,
      created_at: response.created_at,
      publish_at: response.publish_at,
      updated_at: response.updated_at,
      business_unit_uuid: '',
      published_at: '',
      deleted_at: '',
      team_uuid: response?.team_uuid,
      team_name: response?.team_name,
      team_image: response?.team_image,
    };
  }
}
